$("#process-view-content a").click(function (e){
  e.preventDefault();
  $("#process-list-in-popup li a").removeClass('active');
  var href = $(this).attr('href');
  var href2 = window.location.origin + href;
  var link = $("#process-list-in-popup li a[href='"+ href2 +"']");
  var js_file = '<script src="/js/redirect_to_process.js"></script>';

  $.ajaxSetup({
    header:$('meta[name="_token"]').attr('content')
  });
  $.ajax({
      type: "GET",
      url: href,
      dataType: "JSON",
      success: function(data) {
        link.addClass('active');
        $("#process-view-content").html(data.content + js_file);
        $("#process-view-title").html(data.title);
        $("#process-download").html('<a class="btn btn-default" href="' + data.download + '">'+ data.text_download +'</a>');
      },
      error: function(data){
      }
  }); 
}); 